import { Tooltip, IconButton } from '@chakra-ui/react';

import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as MinusIcon } from 'assets/icons/minus.svg';
import { TOOLBAR_COMPONENT_HEIGHT } from 'constants/editor';
import { ReactElement } from 'react';

export enum StepperType {
  Increment = 'increment',
  Decrement = 'decrement',
}

interface NumberInputStepperProps {
  type: StepperType;
  onClick: () => void;
  label: string;
  // Stepper button tooltip label showing keyboard shortcut
  shortCutLabel?: ReactElement;
  stepperBtnStyles?: {
    width?: number;
    noBorder?: boolean;
    // can add more props when needed
  };
}

export const NumberInputStepper = ({
  type,
  onClick,
  label,
  shortCutLabel,
  stepperBtnStyles,
}: NumberInputStepperProps) => {
  let icon, borderProps;
  switch (type) {
    case StepperType.Increment:
      icon = <PlusIcon width={'15px'} strokeWidth={2} stroke={'black'} />;
      borderProps = {
        borderLeftRadius: 'none',
        borderRightRadius: 'base',
        borderLeft: 'none',
        borderRight: !stepperBtnStyles?.noBorder ? '1px solid' : undefined,
      };
      break;
    case StepperType.Decrement:
      icon = <MinusIcon width={'15px'} />;
      borderProps = {
        borderLeftRadius: 'base',
        borderRightRadius: 'none',
        borderLeft: !stepperBtnStyles?.noBorder ? '1px solid' : undefined,
        borderRight: 'none',
      };
      break;
    default:
      break;
  }
  const { noBorder, ...restStepperBtnStyles } = { ...stepperBtnStyles };
  const styleProps = { ...borderProps, ...restStepperBtnStyles };

  return (
    <Tooltip hasArrow placement={'bottom'} label={shortCutLabel ?? label} bg='black'>
      <IconButton
        data-testid={`number-input-${type}-stepper`}
        onClick={onClick}
        icon={icon}
        aria-label={label}
        size={'xs'}
        height={TOOLBAR_COMPONENT_HEIGHT}
        variant={'outline'}
        border={!noBorder ? '1px solid' : undefined}
        borderColor={!noBorder ? 'gray.500' : undefined}
        _hover={{ bg: 'hover.gray' }}
        {...styleProps}
      />
    </Tooltip>
  );
};
